import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import NewSupplier from "./NewSupplier";
import { useGetSuppliersQuery } from "../../features/api/supplierApi";
import {
  useAddPurchaseMutation,
  useGetPurchasesQuery,
} from "../../features/api/purchaseApi";
import { useGetTransactionQuery } from "../../features/api/transactionApi";
import { toast } from "react-toastify";
import { useGetProductQuery } from "../../features/api/productApi";
import { useGetAllModelQuery } from "../../features/api/modelApi";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi";
import CrateUnit from "../CategoryManagement/Unit/CrateUnit";
import AddProduct from "../CategoryManagement/Product/AddProduct";
import AddSubCategory from "../CategoryManagement/SubCategory/AddSubCategory";
import { getuser } from "../../components/CommonDateFormat";
import SearchableSelect from "../../components/SearchableSelect";

const CreatePurchase = () => {
  const user = getuser();

  const [subCatId, setSubCategory] = useState(1);
  const [proId, setProduct] = useState("");
  const [modelId, setModelId] = useState("");
  const [ch_date, setChDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setChDate(currentDate);
  }, []);
  const [challanNo, setChallanNo] = useState("");
  const [suppId, setSuppId] = useState("");
  const [insertId, setInsertId] = useState("");

  const suppliers = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;
  const findModel =
    productModels?.find((item) => item?.model_id == modelId) || {};

  const purchases = useGetPurchasesQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;

  let maxPurNo = 0;
  purchases?.map((data) => {
    const purNo = data?.pu_no;
    const separate = purNo?.split("-")[2];
    if (!isNaN(separate) && +separate > +maxPurNo) {
      maxPurNo = separate;
    }
  });
  const genPurNo = `JES-PU-${+maxPurNo + 1}`;

  const allJv = useGetTransactionQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.transactions;

  let maxJv = 0;
  allJv?.forEach((jv) => {
    const jvNo = jv?.jv_no;
    const separateInv = jvNo?.split("-");
    const separateInvAgain = separateInv?.[2];
    if (!isNaN(separateInvAgain) && +separateInvAgain > +maxJv) {
      maxJv = +separateInvAgain;
    }
  });

  const currentYear = new Date(ch_date).getFullYear();
  const newJvNo = `JV-${currentYear}-${+maxJv + 1}`;

  // for save multiple purchase data
  const [newArray, setNewArray] = useState([]);
  const subTotal = newArray?.reduce((sum, item) => sum + item?.total, 0);
  const handleAddItem = () => {
    if (suppId === "") {
      toast.error("Supplier must required..");
    } else {
      setNewArray([
        ...newArray,
        {
          ch_no: challanNo,
          ch_date: ch_date,
          supp_id: suppId,
          model_id: modelId,
          product: findModel?.product + " - " + findModel?.model_name,
          serial_no: "",
          rmks: "",
          unit_price: 0,
          qty: 0,
          total: 0,
        },
      ]);
    }
  };

  const handleSerialChange = (index, serial) => {
    const updatedData = [...newArray];
    updatedData[index].serial_no = serial;
    setNewArray(updatedData);
  };

  const handleRemarksChange = (index, desc) => {
    const updatedData = [...newArray];
    updatedData[index].rmks = desc;
    setNewArray(updatedData);
  };

  // handle quantity for individual product
  const handleQuantityChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].qty = qty;
    updatedData[index].avl_qty = qty;
    updatedData[index].total = qty * updatedData[index].unit_price;
    setNewArray(updatedData);
  };

  // handle unit_price for individual product
  const handlePriceChange = (index, unit_price) => {
    const updatedData = [...newArray];
    updatedData[index].unit_price = unit_price;
    updatedData[index].total = unit_price * updatedData[index].qty;
    setNewArray(updatedData);
  };

  // remove from product list before purchase
  const handleRemove = (index) => {
    const restProduct = [...newArray];
    restProduct.splice(index, 1);
    setNewArray(restProduct);
  };

  const [createNewPurchase] = useAddPurchaseMutation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handlePurchase = async () => {
    setLoading(true);

    try {
      const response = await createNewPurchase({
        jv_no: newJvNo,
        pu_no: genPurNo,
        ch_no: challanNo,
        ch_date: ch_date,
        supp_id: suppId,
        sub_total: subTotal,
        created_by: user?.id,
        items: newArray,
      });

      if (response?.data) {
        setInsertId(response?.data?.insertId);
        setLoading(false);
        // navigate("/dashboard/purchase");
      } else if (response?.error) {
        setLoading(false);
        toast.error("failed to create");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating data:", error?.response);
    }
  };

  useEffect(() => {
    if (insertId) {
      navigate(`/dashboard/purchase-view/${insertId}`);
    }
  }, [insertId]);
  return (
    <div className=" bg-slate-200 h-full">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Create Purchase</h1>
        <div className="flex items-center gap-x-4">
          <AddSubCategory />
          <AddProduct />
          <CrateUnit />
          <NewSupplier />
          <Link
            to="/dashboard/purchase"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
        </div>
      </div>
      <div>
        <div className="p-4 my-4 border">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="flex flex-col gap-1">
              <label className="font-bold">Purchase No.</label>
              <input
                type="text"
                value={genPurNo}
                disabled
                className="border h-8 pl-1 bg-slate-50"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Chalan No.</label>
              <input
                type="text"
                value={challanNo}
                onChange={(e) => setChallanNo(e.target.value)}
                className="border h-8 pl-1 focus:outline-none bg-slate-50"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Chalan Date</label>
              {/* <DateTimePicker
                  value={ch_date}
                  onChange={setChDate}
                  className="bg-slate-50 h-8"
                /> */}
              <input
                type="date"
                value={ch_date}
                onChange={(e) => setChDate(e.target.value)}
                className="border h-8 pl-1 focus:outline-none bg-slate-50"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Supplier Name</label>

              <SearchableSelect
                options={[
                  { value: "", label: "--select--" },
                  ...(suppliers?.map((i) => ({
                    value: i?.id,
                    label: i?.s_name,
                  })) || []),
                ]}
                value={suppId}
                onChange={(e) => setSuppId(Number(e.target.value))}
              />
              {/* <select
                  value={suppId}
                  onChange={(e) => setSuppId(e.target.value)}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {suppliers?.map((supplier) => (
                    <option
                      key={supplier?.id}
                      value={supplier?.id}
                      className="text-sm"
                    >
                      {supplier?.s_name} - {supplier?.s_mobile}
                    </option>
                  ))}
                </select> */}
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full my-4">
            <div className="flex flex-col gap-1 ">
              <label className="font-medium">Brand</label>
              <select
                value={subCatId}
                onChange={(e) => setSubCategory(e.target.value)}
                className="border h-8 pl-1 bg-slate-50"
              >
                <option>--select--</option>
                {subCategory?.map((sCat) => (
                  <option key={sCat?.id} value={sCat?.id}>
                    {sCat?.sub_catName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-medium">Product / Spare Parts </label>

              <SearchableSelect
                options={[
                  { value: "", label: "--select--" },
                  ...(products?.map((i) => ({
                    value: i?.id,
                    label: i?.product_name,
                  })) || []),
                ]}
                value={proId}
                onChange={(e) => setProduct(Number(e.target.value))}
              />
              {/* <select
                  onChange={(e) => setProduct(Number(e.target.value))}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {products?.map((product) => (
                    <option key={product?.id} value={product?.id}>
                      {product?.product_name}
                    </option>
                  ))}
                </select> */}
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-medium">Machine Model</label>

              <SearchableSelect
                options={[
                  { value: "", label: "--select--" },
                  ...(productModels
                    ?.filter((model) => model.product_id === +proId)
                    .map((i) => ({
                      value: i?.model_id,
                      label: i?.model_name,
                    })) || []),
                ]}
                value={modelId}
                onChange={(e) => setModelId(Number(e.target.value))}
              />
              {/* <select
                  onChange={(e) => {
                    setModelId(Number(e.target.value));
                  }}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {productModels
                    ?.filter((model) => model.product_id === +proId)
                    .map((model) => (
                      <option key={model?.model_id} value={model?.model_id}>
                        {model?.model_name}
                      </option>
                    ))}
                </select> */}
            </div>
          </div>
          <button
            onClick={() => handleAddItem()}
            className="bg-blue-500 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Add Item
          </button>
        </div>
        <div className="p-4 m-4 border mx-auto overflow-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Model
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Serial
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Purchase Rate
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Total Price
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {newArray?.map((data, index) => {
                return (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.product}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleSerialChange(index, e.target.value)
                        }
                        className="border pl-1 w-24"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <textarea
                        onChange={(e) =>
                          handleRemarksChange(index, e.target.value)
                        }
                        className="border focus:outline-none text-sm h-8"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handlePriceChange(index, Number(e.target.value))
                        }
                        type="text"
                        className="border pl-1 w-24"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handleQuantityChange(index, Number(e.target.value))
                        }
                        type="text"
                        className="border pl-1 w-16"
                      />
                    </td>

                    {/* <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                  <select
                    onChange={(e) => handleWharehouse(index, e.target.value)}
                    className="border h-8 pl-1"
                  >
                    <option>--select--</option>
                    {warehouses?.map((product) => (
                      <option key={product?.id}>{product?.wh_name}</option>
                    ))}
                  </select>
                </td> */}

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <button
                        onClick={() => handleRemove(index)}
                        className=" text-red-500 text-2xl"
                      >
                        x
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th
                  colSpan={5}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-semibold uppercase tracking-wider"
                >
                  Sub - Total:
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-semibold uppercase tracking-wider">
                  {subTotal}
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"></th>
              </tr>
            </tfoot>
          </table>
          <button
            onClick={() => handlePurchase()}
            className={`bg-green-500 text-white font-bold px-4 py-1 mt-8 rounded `}
          >
            {loading ? "Loading..." : "Purchase"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePurchase;
